export function isInitialCredentialResponse(v) {
    return Boolean(v &&
        typeof v === 'object' &&
        typeof v.temporaryPassword === 'string' &&
        typeof v.expiresAt === 'string');
}
